import { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [adminValid, setAdminValid] = useState(false); // ← これだけで管理
  const [popupMessage, setPopupMessage] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const storedRole = localStorage.getItem("role");

    if (token) {
      setIsAuthenticated(true);
      setAdminValid(storedRole === "admin");
    } else {
      setIsAuthenticated(false);
    }
  }, []);

  const login = async (email, password) => {
    try {
      // const response = await fetch("http://127.0.0.1:8000/api/auth/login", {
      const response = await fetch("/api/auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        throw new Error("ログインに失敗しました");
      }

      const data = await response.json();

      localStorage.setItem("access_token", data.access_token);
      localStorage.setItem("user_id", data.user_id);
      localStorage.setItem("role", data.role); // "admin" または "user"

      setIsAuthenticated(true);
      setAdminValid(data.role === "admin");

      navigate("/");
      return true;
    } catch (error) {
      console.error("ログインエラー:", error);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("role");

    setIsAuthenticated(false);
    setAdminValid(false);
    navigate("/login");
  };

  const handleNavigation = (path, isValid, navigate) => {
    if (!isValid) {
    navigate(path)
    } else {
      navigate(path);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        login,
        logout,
        adminValid,
        handleNavigation,
        popupMessage,
        setPopupMessage,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
